import { render } from "./RightHall.vue?vue&type=template&id=7dcd2032"
import script from "./RightHall.vue?vue&type=script&lang=ts"
export * from "./RightHall.vue?vue&type=script&lang=ts"
script.render = render

export default script